import { render, staticRenderFns } from "./TkHotelNCovidInformation.vue?vue&type=template&id=17e1b615&"
import script from "./TkHotelNCovidInformation.vue?vue&type=script&lang=js&"
export * from "./TkHotelNCovidInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports